"use client";
import Image from "next/image";
import Section from "@/components/static/Section";
import { SectionPadding, HeadlineProps, ImageProps, ButtonProps } from "@/lib/types";

type Content = {
    settings: {
        padding: SectionPadding;
    };
    productProperties: [
        {
            icon: ImageProps;
            value: string;
        }
    ];
};

export default function Layout_128({ content }: { content: Content }) {
    return (
        <Section dataComponent='Layout_128' settings={content.settings}>
            <div className='container'>
                <div className='grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-y-8 gap-x-4'>
                    {content.productProperties.map((property, key) => (
                        <div key={key} className='flex flex-col items-center justify-center'>
                            <Image
                                src={property.icon.url}
                                height={property.icon.height}
                                width={property.icon.width}
                                alt={property.icon.alt ?? "Icon"}
                                className='size-18'
                            />
                            <div key={key} className='text-h5 mt-6'>
                                {property.value}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
}
